import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { getCreditDebitNoteDetails } from '../../../../redux/actions/SocietyPortal/CreditDebitNoteAction/CreditDebitNoteAction';
import NotePrintPage from './components/NotePrintPage';

const PrintNote = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();
    const { noteDetails, detailsLoading } = useSelector(state => state.CreditDebitNoteReducer || {});

    useEffect(() => {
        if (id) {
            dispatch(getCreditDebitNoteDetails({ id }));
        }
    }, [dispatch, id]);

    const handlePrint = () => window.print();
    const handleBack = () => navigate(-1);

    if (detailsLoading || !noteDetails) {
        return (
            <div className="tw-min-h-screen tw-flex tw-items-center tw-justify-center tw-bg-gray-50">
                <div className="tw-text-center">
                    <div className="tw-animate-spin tw-rounded-full tw-h-12 tw-w-12 tw-border-b-2 tw-border-indigo-600 tw-mx-auto"></div>
                    <p className="tw-text-gray-500 tw-mt-4 tw-text-sm">Loading note...</p>
                </div>
            </div>
        );
    }

    const isCreditNote = noteDetails.note_type === 'CREDIT_NOTE';
    const noteLabel = isCreditNote ? 'Credit Note' : 'Debit Note';
    const documentNumber = noteDetails.document_number || noteDetails.note_id;

    return (
        <>
            <style>{`
                @media print {
                    body { margin: 0; padding: 0; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                    .no-print { display: none !important; }
                    .print-page { margin: 0; padding: 6mm; box-shadow: none !important; border: none !important; }
                    @page { size: A4; margin: 8mm; }
                }
            `}</style>

            <div className="no-print tw-bg-white tw-border-b tw-border-gray-200 tw-sticky tw-top-0 tw-z-10 tw-shadow-sm">
                <div className="tw-max-w-4xl tw-mx-auto tw-px-6 tw-py-3 tw-flex tw-items-center tw-justify-between">
                    <div className="tw-flex tw-items-center tw-gap-3">
                        <button onClick={handleBack} className="tw-p-2 tw-rounded-lg hover:tw-bg-gray-100 tw-text-gray-500 tw-transition-colors">
                            <Icon icon="mdi:arrow-left" className="tw-text-xl" />
                        </button>
                        <div>
                            <h1 className="tw-text-lg tw-font-bold tw-text-gray-900">Print {noteLabel}</h1>
                            <p className="tw-text-xs tw-text-gray-500">{documentNumber}</p>
                        </div>
                    </div>
                    <div className="tw-flex tw-items-center tw-gap-3">
                        <button onClick={handleBack} className="tw-px-4 tw-py-2 tw-bg-white tw-border tw-border-gray-300 tw-rounded-lg tw-text-sm tw-font-medium tw-text-gray-700 hover:tw-bg-gray-50 tw-transition-colors">
                            Back
                        </button>
                        <button onClick={handlePrint} className={`tw-flex tw-items-center tw-gap-2 tw-px-5 tw-py-2 ${isCreditNote ? 'tw-bg-emerald-600 hover:tw-bg-emerald-700' : 'tw-bg-orange-600 hover:tw-bg-orange-700'} tw-text-white tw-rounded-lg tw-text-sm tw-font-semibold tw-transition-colors tw-shadow-sm`}>
                            <Icon icon="mdi:printer" className="tw-text-lg" /> Print
                        </button>
                    </div>
                </div>
            </div>

            <div className="tw-bg-gray-100 tw-min-h-screen tw-py-8 no-print-bg">
                <NotePrintPage
                    note={noteDetails}
                    pageIdx={0}
                    totalPages={1}
                    className="print-page tw-max-w-4xl tw-mx-auto tw-bg-white tw-shadow-lg tw-border tw-border-gray-200"
                />
            </div>
        </>
    );
};

export default PrintNote;
